export const singleGridItem = { size: 12 };